module.exports = {
  social_deduction_games_online: {
    title: 'Социальная дедукция: игры после «Мафии»',
    description:
      'Играете в «Мафию» онлайн с друзьями? Сравните Авалон, Secret Hitler, «Оборотней» и Among Us: роли и выбывание.',
    keywords: ['социальная дедукция'],
    breadcrumbs: [
      {
        to: '/ru/',
        title: 'Главная',
      },
      {
        to: '/ru/guides/social-deduction-games-online/',
        title: 'Игры на социальную дедукцию',
      },
    ],
  },
  games_like_secret_hitler: {
    title: 'Игры, похожие на Secret Hitler: Авалон онлайн',
    description:
      'Сравните Secret Hitler и Авалон: тайные команды, голоса и миссии. Играйте с друзьями или учитесь с ботами.',
    keywords: ['игры, похожие на Secret Hitler'],
    breadcrumbs: [
      {
        to: '/ru/',
        title: 'Главная',
      },
      {
        to: '/ru/guides/social-deduction-games-online/',
        title: 'Игры на социальную дедукцию',
      },
      {
        to: '/ru/guides/games-like-secret-hitler/',
        title: 'Игры, похожие на Secret Hitler',
      },
    ],
  },
  avalon_vs_werewolf: {
    title: 'Игры, похожие на настольную «Мафию» | Авалон',
    description:
      'Авалон как альтернатива классической настольной «Мафии»: команды вместо исключения игроков. Сравните роли и голоса.',
    keywords: ['настольные игры похожие на мафию'],
    breadcrumbs: [
      {
        to: '/ru/',
        title: 'Главная',
      },
      {
        to: '/ru/guides/social-deduction-games-online/',
        title: 'Игры на социальную дедукцию',
      },
      {
        to: '/ru/guides/avalon-vs-werewolf/',
        title: 'Авалон и настольная «Мафия»',
      },
    ],
  },
};
